import React from 'react';
import PropTypes from 'prop-types';

class Toggler extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { open: props.initial || false }
  }
  toggle() {
    this.setState(p => ({ open: !p.open }));
  }
  render() {
    return this.props.children({ open: this.state.open, toggle: this.toggle });
  }
}

Toggler.propTypes = {
  initial: PropTypes.bool,
  children: PropTypes.func.isRequired,
};
export default Toggler;


// WEBPACK FOOTER //
// ./src/components/Toggler.jsx